module.exports = __webpack_public_path__ + "img/skin.b41bf020.svg";